var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"7","height":"12","viewBox":"0 0 7 12","fill":"none"}},[_c('path',{attrs:{"d":"M0.833984 10.833L5.83398 5.83301L0.833984 0.833008","stroke":_vm.color,"stroke-width":"1.66667","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }